<h1 mat-dialog-title class="d-flex align-items-center justify-content-between">
    <span>Rate the Artifactory </span>
    <i class="fa fa-times model_close cursor-pointer" (click)="close()"></i>
</h1>

<div mat-dialog-content class="popup-content">

    <div *ngFor="let review of ratinglist">
        <div>
            <div class="d-flex justify-content-between labelName">
                <div><i class="fas fa-solid fa-user"></i> {{ 
                    review.email.split('@')[0].replace('.',' ') | titlecase
                }}                
                </div>
                <div><i class="fa fa-star" aria-hidden="true"></i>{{review.rating}}/5</div>
            </div>
            <div class="labelName ellipsis_three_line_text"><span class="fw-600">Comment :</span> {{review.comments !== 'undefined' ? review.comments : ''}}</div>
            <hr class="m-1">
        </div>
    </div>

    <div>
        <label class="mb-0 d-inline-flex align-items-center"> <span class="labelName">Rating :</span><igc-rating [value]="data.ratings.rating"
            min="1" max="5" (igcChange)="ratingChanged($event);"></igc-rating> </label>
        <textarea id="comments" rows="2" cols="50" class="form-control mt-2 mb-2" (blur)="AddComments($event) "
            [(ngModel)]="data.ratings.comments" placeholder=" Your Comments"></textarea>
    </div>

</div>
<div mat-dialog-actions class="popup-buttons d-flex justify-content-end">
    <button *ngIf="!existingUser; else updateButton" class="custom_btn primary_btn_base"
        (click)="closeDialog()" [disabled]="!this.data?.starRating">Submit</button>
    <ng-template #updateButton>
        <button  class="custom_btn primary_btn_base"
            (click)="closeDialog1()" [disabled]="!this.data?.starRating">Update</button>
    </ng-template>
    <button class="custom_btn inverted_btn_base ml-2" (click)="close()">Cancel</button>
</div>